import React from "react";
import SalesConfigPanel from "./SalesConfigPanel";
import { PurchaseConfigPanel } from "./PurchaseConfigPanel";
import ReturnsConfigPanel from "./ReturnsConfigPanel";
import OtherConfigPanel from "./OtherConfigPanel";
import AccountConfigPanel from "./AccountConfigPanel";
import EmailCongifPanel from "./EmailConfigPanel";
import IntegrationConfigPanel from "./IntegrationConfigPanel";

const ConfiguationDetails = ({
  activeComponent,
  handleFormChange,
  handleTextFormChange,
}) => {
  return (
    <>
      {activeComponent.id === 0 ? (
        <AccountConfigPanel
          handleFormChange={handleFormChange}
          handleTextFormChange={handleTextFormChange}
        />
      ) : activeComponent.id === 1 ? (
        <SalesConfigPanel handleFormChange={handleFormChange} />
      ) : activeComponent.id === 2 ? (
        <PurchaseConfigPanel handleFormChange={handleFormChange} />
      ) : activeComponent.id === 3 ? (
        <ReturnsConfigPanel handleFormChange={handleFormChange} />
      ) : activeComponent.id === 4 ? (
        <IntegrationConfigPanel handleFormChange={handleFormChange} />
      ) : activeComponent.id === 5 ? (
        <OtherConfigPanel handleFormChange={handleFormChange} />
      ) : activeComponent.id === 6 ? (
        <EmailCongifPanel handleFormChange={handleFormChange} />
      ) : (
        // <BillPrintingConfigPanel handleFormChange={handleFormChange} />
        <SalesConfigPanel
          handleFormChange={handleFormChange}
          handleTextFormChange={handleTextFormChange}
        />
      )}
    </>
  );
};
export default ConfiguationDetails;
